import { overrideBaseLocale } from './base-config';
export var enPT = overrideBaseLocale('en-PT', {});
//# sourceMappingURL=en-PT.js.map